/* maeda-en® - 2026/08/11 - Products megamenuのTea Types列: ホバー/フォーカスした項目の商品(1枚目の画像・商品名)に
   右側カードの画像・キャプション・リンク先を切替。リセットはマウス位置(mouseout/relatedTarget)ではなく、
   このmegamenu自体の<details>が閉じた(toggleイベントでopen=false)時にのみ行う。
   マウス位置ベースの判定は境界ケースが多く（列⇔画像間の余白でリセット→クリック不可、
   relatedTargetがnullになる場合の誤リセット等）2回連続で不具合の原因になったため、
   details-disclosure.jsが使っている「開閉」という単一の確実なシグナルに統一した */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.mae-mm__types').forEach(function (typesList) {
      var content = typesList.closest('.mega-menu__content');
      var details = content ? content.closest('details') : null;
      var card = content ? content.querySelector('[data-mm-card]') : null;
      var img = card ? card.querySelector('img') : null;
      var title = card ? card.querySelector('[data-mm-caption]') : null;
      if (!content || !details || !card || !img) return;

      var defaults = {
        src: img.getAttribute('src'),
        srcset: img.getAttribute('srcset'),
        alt: img.getAttribute('alt'),
        href: card.tagName === 'A' ? card.getAttribute('href') : null,
        title: title ? title.textContent : ''
      };

      /* maeda-en® - 2026/08/11 - 画像を即時切替すると点滅して見えるため、一旦フェードアウト→差し替え→フェードイン
         (CSS側は.mae-mm__card imgにtransition: opacityを指定) */
      var fadeTimer = null;
      var FADE_MS = 120;
      /* maeda-en® - 2026/08/11 - 現在表示中の対象(Tea Typeのlink要素、またはデフォルト状態ならnull)を記録し、
         同じ対象に再度ホバーした時は無駄なフェードを再生しないようにする */
      var activeLink = null;

      function applyChange(applyFn) {
        if (fadeTimer) clearTimeout(fadeTimer);
        img.style.opacity = '0';
        fadeTimer = setTimeout(function () {
          applyFn();
          img.style.opacity = '1';
        }, FADE_MS);
      }

      function swap(link) {
        if (link === activeLink) return;
        activeLink = link;
        applyChange(function () {
          img.setAttribute('src', link.dataset.mmImg);
          img.removeAttribute('srcset');
          img.setAttribute('alt', link.dataset.mmAlt || '');
          if (card.tagName === 'A' && link.dataset.mmUrl) {
            card.setAttribute('href', link.dataset.mmUrl);
          }
          if (title) {
            title.textContent = link.dataset.mmTitle || '';
          }
        });
      }

      function reset() {
        if (activeLink === null) return;
        activeLink = null;
        applyChange(function () {
          img.setAttribute('src', defaults.src);
          if (defaults.srcset) {
            img.setAttribute('srcset', defaults.srcset);
          } else {
            img.removeAttribute('srcset');
          }
          img.setAttribute('alt', defaults.alt || '');
          if (card.tagName === 'A') {
            /* maeda-en® - 2026/08/11 - デフォルトにリンクが無い場合(defaults.hrefがnull)はhrefを完全に外す。
               setAttributeのみだとホバーで付与されたhrefがリセット時に残ってしまう */
            if (defaults.href) {
              card.setAttribute('href', defaults.href);
            } else {
              card.removeAttribute('href');
            }
          }
          if (title) {
            title.textContent = defaults.title;
          }
        });
      }

      content.addEventListener('mouseover', function (event) {
        var link = event.target.closest('[data-mm-img]');
        if (link) swap(link);
      });
      content.addEventListener('focusin', function (event) {
        var link = event.target.closest('[data-mm-img]');
        if (link) swap(link);
      });
      details.addEventListener('toggle', function () {
        if (!details.open) reset();
      });
    });
  });
})();
